import { Components, Theme } from '@mui/material/styles';

declare module '@mui/material/CircularProgress' {
  interface CircularProgressPropsColorOverrides {
    forest: true;
    oceanTint: true;
    sandShade2: true;
    desert: true;
    taigaTint1: true;
  }
}

export default function MuiCircularProgress(theme: Theme): Components['MuiCircularProgress'] {
  return {};
}
